<template>
    <LoadingComponent :props="loading" />
    <section v-if="benefits.length > 0" class="hidden sm:block py-6 mb-10 border-b border-slate-100">
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div v-for="benefit in benefits" :key="benefit.id" class="w-full max-w-[236px] relative ltr:lg:pl-9 rtl:lg:pr-9">
                    <img :src="benefit.thumb" alt="benefit" class="w-6 mb-2 lg:mb-0 lg:absolute lg:top-0.5 ltr:lg:left-0 rtl:lg:right-0">
                    <h4 class="text-base font-semibold font-title capitalize">{{ benefit.title }}</h4>
                </div>
            </div>
        </div>
    </section>
    <div class="block sm:hidden mb-10"></div>
</template>

<script>
import statusEnum from "../../../enums/modules/statusEnum";
import LoadingComponent from "../components/LoadingComponent";

export default {
    name: "TopBenefitComponent",
    components: {
        LoadingComponent
    },
    data() {
        return {
            loading: {
                isActive: false,
            }
        }
    },
    computed: {
        benefits: function () {
            return this.$store.getters["frontendBenefit/lists"];
        },
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch("frontendBenefit/lists", {
            paginate: 0,
            order_column: "id",
            order_type: "asc",
            status: statusEnum.ACTIVE,
        }).then(res => {
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });
    }
}
</script>
